import React, { FC, useEffect } from 'react';
import { fetchAuditLogs, setAuditLogSTablePagination } from '../../store/merchnts/actions/audit-logs';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { TablesNames } from '../../store/tables/tables-context';
import { Table } from '../../components/table/Table';
import { AuditLogsDetailsPanel } from '../../components/audit-logs/AuditLogsDetailsPanel';

export const AuditLogs: FC = () => {

	const { merchantState, dispatch } = useMerchants();
	const {
		auditLogsList,
		isAuditLogsListLoading,
		auditLogsListTotalItemCount,
		auditLogsListTablePageSize,
		auditLogsListTablePageNumber
	} = merchantState;


	useEffect(() => {
		void fetchAuditLogs(dispatch);
	}, []);

	return (
		<Table
			name={TablesNames.auditLogsTableData}
			data={auditLogsList}
			pageNumber={auditLogsListTablePageNumber}
			pageSize={auditLogsListTablePageSize}
			isLoading={isAuditLogsListLoading}
			totalItemCount={auditLogsListTotalItemCount}
			setPagination={(value): void => setAuditLogSTablePagination(dispatch, value)}
			renderDetailPanel={AuditLogsDetailsPanel}
		/>
	);
};